module.exports = __webpack_public_path__ + "static/media/icon-aviso-monitoramento.18682642.png";